// Original FieldMappingModal - compatible with existing components
import React from 'react';

export interface FieldMapping {
  originalName: string;
  mappedName: string;
  confidence: number;
  isRequired: boolean;
}

export interface CSVDialect {
  delimiter: string;
  encoding: string;
  hasHeader: boolean;
}

// Re-export types from FieldMappingUtils for compatibility
export * from './FieldMappingUtils';

// Props interface that matches the usage in TestlabTaxAccountPage
interface FieldMappingModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  csvHeaders: string[];
  csvPreview: string[][];
  suggestedMappings: FieldMapping[];
  requiredFields: string[];
  optionalFields: string[];
  onConfirm: (mapping: Record<string, string>) => Promise<void>;
  onCancel: () => void;
}

// Placeholder implementation - can be enhanced later
export function FieldMappingModal({
  open,
  onOpenChange,
  csvHeaders,
  csvPreview,
  suggestedMappings,
  requiredFields,
  optionalFields,
  onConfirm,
  onCancel
}: FieldMappingModalProps) {
  // For now, just return null to prevent build errors
  // This can be implemented properly later if needed
  return null;
}